import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
} from 'chart.js';

import Loader from '@/components/Loader';
import { LineChartProps } from '@/components/LineChart/LineChartTypes';
import {
  StyledWrapper,
  StyledLineChart,
  StyledScrollWrapper,
} from '@/components/LineChart/LineChartStyled';

import { chartOptions } from '@/resources/constants';

import useUserInfo from '@/hooks/useUserInfo';
import useChartJs from '@/hooks/useChartJs';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MAX_DAYS = 14;

const LineChart = ({ isLoading, data }: LineChartProps) => {
  const { isMaster } = useUserInfo();

  const chartData = useChartJs(data);

  if (isLoading) {
    return (
      <StyledWrapper $isFetching>
        <Loader isStatic size={32} />
      </StyledWrapper>
    );
  }

  const showScroll =
    data && !isMaster && !isLoading && data.data?.statistics
      ? data.data.statistics.length > MAX_DAYS
      : Boolean(data?.parameters?.length);

  return (
    <StyledScrollWrapper>
      <StyledWrapper $showScroll={showScroll}>
        <StyledLineChart options={chartOptions} data={chartData} />
      </StyledWrapper>
    </StyledScrollWrapper>
  );
};

export default LineChart;
